module.exports = __webpack_public_path__ + "static/media/envoi.7e697151.png";